__turbopack_context__.v({
  "empty": "MobileTransactionsList-module-scss-module__fY_qnW__empty",
  "emptyNoPadding": "MobileTransactionsList-module-scss-module__fY_qnW__emptyNoPadding",
  "root": "MobileTransactionsList-module-scss-module__fY_qnW__root",
  "txList": "MobileTransactionsList-module-scss-module__fY_qnW__txList",
  "viewAllButton": "MobileTransactionsList-module-scss-module__fY_qnW__viewAllButton",
});
